module.exports = __webpack_public_path__ + "img/home_active.cc40b6f2.svg";